import React, { Component } from 'react';
import { Form, Modal, Table } from 'antd';

import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFileTable';

const FormItem = Form.Item;

class ModalAccount extends Component {
  handleOk = () => {
    const { effect } = this.props;
    const neweffect = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        effect.map(item => {
          const valueScan = values[`scan${item.uuid}`];
          if (valueScan && valueScan.length > 0) {
            item.scan = valueScan[0];
          } else {
            item.scan = null;
          }
          neweffect.push({
            fileUuid: item.uuid,
            scan: item.scan,
          });

          if (item.delFiles.length > 0) {
            item.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          return item;
        });

        this.props.handleOk({ files: neweffect });
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  scanColumns = () => {
    const { getFieldDecorator } = this.props.form;
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.uuid}`)(<span>{record.name || '暂无名称'}</span>)}
            </FormItem>
          );
        },
      },
      {
        title: '扫描件',
        dataIndex: 'scan',
        key: 'scan',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`scan${record.uuid}`, {
                initialValue: record.scan ? [record.scan] : [],
              })(
                <UploadFile
                  limit={1}
                  type="ghost"
                  isPreview
                  onRemove={file => this.fileRemove(record, file)}
                />,
              )}
            </FormItem>
          );
        },
      },
    ];
  };

  render() {
    const { visible, handleCancel, effect, confirmLoading } = this.props;
    return (
      <Modal
        title="上传扫描件（用章后）"
        visible={visible}
        onOk={this.handleOk}
        okText="通过"
        confirmLoading={confirmLoading}
        onCancel={() => handleCancel(false)}
        width="40%"
      >
        <Form>
          <Table
            columns={this.scanColumns()}
            dataSource={effect}
            pagination={false}
            rowKey={record => record.uuid}
          />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/incubatorScan/ModalScanUpload.js